<template>
    <div v-if="isAuthenticated">
        authenticated
    </div>

    <be-splash-screen v-else wrapper-class="be-login">

        <be-alert color="warning" icon="alert-triangle" v-if="isDemoSystem">
            <p><strong>{{demoMessage}}</strong></p>
        </be-alert>

        <be-loading :active="loading">
            <be-card border-color="primary" :header-color="isHeidilandSystem ? 'primary' : ''">
                <template slot="header">
                    <router-link :to="{ name: 'home' }">
                        <img class="logo-img" src="../../../assets/images/logo--grf.svg" alt="Graubünden Logo" width="200" height="40" v-if="isGrfSystem">
                        <img class="logo-img" src="../../../assets/images/logo--heidiland.svg" alt="Graubünden Logo" width="200" height="40" v-else-if="isHeidilandSystem">
                        <img class="logo-img" src="../../../assets/images/logo.svg" alt="Digital.Fitness Logo" width="102" height="27" v-else>
                    </router-link>
                    <span class="splash-description" :class="{ 'text-white': isHeidilandSystem }">Geben Sie Ihre Zugangsdaten ein.</span>
                </template>

                <form action="#" method="post" @submit.prevent="submitLogin">
                    <text-field autofocus ref="email" name="email" placeholder="E-Mail Adresse" autocomplete="off" v-model="email" :validation="$v.email"/>
                    <text-field name="password" placeholder="Passwort" v-model="password" :validation="$v.password"/>

<!--
                    <div class="form-group row login-tools">
                        <div class="col-6 login-remember">
                            <label class="custom-control custom-checkbox">
                                <input class="custom-control-input" type="checkbox"><span class="custom-control-label">Merken</span>
                            </label>
                        </div>
                        <div class="col-6 login-forgot-password"><a href="pages-forgot-password.html">Passwort vergessen?</a></div>
                    </div>
-->

                    <div class="form-group login-submit"><button type="submit" class="btn btn-primary btn-xl">Anmelden</button></div>
                </form>
            </be-card>
        </be-loading>

        <!--<span slot="footer">Du hast keinen Account? <a href="https://digital.fitness#preise">Hier registrieren</a></span>-->
    </be-splash-screen>

</template>


<script>
    import { mapGetters } from 'vuex';
    import { required, email } from 'vuelidate/lib/validators';
    import { password } from '../../../validators';
    import env from '../../../mixins/env';

    export default {
        mixins: [env],

        data: () => ({
            email: '',
            password: '',
            loading: false,
        }),

        validations: {
            email: { required, email },
            password: { required, password },
        },

        computed: {
            ...mapGetters('user', ['isAuthenticated']),
        },

        methods: {
            async submitLogin() {
                try {
                    this.loading = true;
                    await this.$store.dispatch('user/login', {
                        email: this.email,
                        password: this.password,
                    });

                    this.$router.push(this.$route.query.redirect || { name: 'home' });
                } catch (err) {
                    this.$store.dispatch('notifications/add', {
                        title: 'Anmeldung fehlgeschlagen',
                        description: 'Für diese E-Mail wurde kein Benutzer gefunden oder das Passwort ist nicht korrekt.',
                    });

                    this.password = '';
                    this.$refs.email.$refs.el.focus();
                } finally {
                    this.loading = false;
                }
            },
        },

        created() {
            if (this.isDemoSystem || this.isDebugMode) {
                this.email = 'demo@digital.fitness';
                this.password = 'demo@digital.fitness';
            }

            if (this.isDebugMode && this.$route.query.redirect && this.$route.query.redirect !== '/') {
                this.submitLogin();
            }
        },
    };
</script>
